export default "__VITE_ASSET__727c114e__"